<ng-template let-item="item">
    <img *ngIf="item.img" class="filter-small-image" [src]="item.img" alt="Icon">
    {{item.name}}
</ng-template>
